import { BACKEND_URL_PREFIX } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { buildDefaultHeaders } from "./helper";
import { SET_REPORTS_LOADING, SET_REPORTS_LIST, SET_REPORT_DATA, SET_REPORT_PERIOD } from "./types";


export const setInitialValues = () => ({type: SET_REPORT_DATA, data: null, name: undefined})
export const setReportPeriod = (payload) => ({type: SET_REPORT_PERIOD, payload})

export const getReportsList = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_REPORTS_LOADING, payload: true });
    const response = await fetch(`${BACKEND_URL_PREFIX}/certification/reports`, {
      method: "GET",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_REPORTS_LIST, payload });
    }
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};

export const getReportData = (reportName) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_REPORTS_LOADING, payload: true });
    const commission_id = getState().reports.commission_id
    const params = commission_id ? { commission_id } : {}
    const stringParams = new URLSearchParams(params).toString()
    const response = await fetch(`${BACKEND_URL_PREFIX}/certification/reports/${reportName}?${stringParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      const payload = await response.json();
      await dispatch({ type: SET_REPORT_DATA, payload, reportName });
    }
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};

export const getExcerptReportData = (orgId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_REPORTS_LOADING, payload: true });
    const commission_id = getState().reports.commission_id
    const params = commission_id ? { commission_id } : {}
    const stringParams = new URLSearchParams(params).toString()
    const response = await fetch(`${BACKEND_URL_PREFIX}/certification/reports/decree_guk/${orgId}?${stringParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      const payload = await response.json();
      await dispatch({ type: SET_REPORT_DATA, payload, reportName: 'excerpt_decree_guk' });
    }
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};


export const getXLSX = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_REPORTS_LOADING, payload: true });
    const commission_id = getState().reports.commission_id
    const params = commission_id ? { commission_id } : {}
    const stringParams = new URLSearchParams(params).toString()
    const response = await fetch(`${BACKEND_URL_PREFIX}/certification/reports/decree_guk_excel?${stringParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      const payload = await response.blob();
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'decree_guk.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    }
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};